import { FaEye } from "react-icons/fa";

export const Proj10 = () => {
  return (
    <article className="relative rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-shadow duration-500 bg-white/5 backdrop-blur-sm mt-4">
      {/* Project Image */}
      <img src="/img/projects/myroutine.png" alt="My Routine App" className="w-full h-64 md:h-72 object-cover rounded-t-2xl" loading="lazy" />

      {/* Project Info */}
      <div className="p-6 space-y-4">
        <h3 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500">My Routine App</h3>
        <p className="text-gray-600 text-lg leading-relaxed">My routine app allows users to set daily routines and track their progress while also providing a space to journal their thoughts and reflections. It helps users stay consistent with their habits and document their personal growth effortlessly.</p>

        <div className="flex justify-center mt-4">
          <a href="https://play.google.com/store/apps/details?id=com.uxcorp.myroutine" target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-5 py-2 rounded-xl font-semibold text-white shadow-md bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 hover:scale-105 transition-transform duration-300" aria-label="View My Routine App on Google Play">
            <FaEye className="mr-2" /> View
          </a>
        </div>
      </div>
    </article>
  );
};
